import { useState, useEffect, useRef } from 'react';
import './Portfolio.css';

import img1 from '../../assets/01.png';
import img2 from '../../assets/02.png';
import img3 from '../../assets/03.png';
import img4 from '../../assets/04.png';
import img5 from '../../assets/05.png';

const slides = [img1, img2, img3, img4, img5];

export default function RevealSection() {
  const [active, setActive] = useState(0);
  const [animating, setAnimating] = useState(false);
  const autoRef = useRef(null);

  const total = slides.length;

  const startAuto = () => {
    clearInterval(autoRef.current);
    autoRef.current = setInterval(() => {
      setActive(prev => (prev + 1) % total);
    }, 3500);
  };

  useEffect(() => {
    startAuto();
    return () => clearInterval(autoRef.current);
  }, []);

  const goTo = (idx) => {
    if (animating) return;
    setAnimating(true);
    setActive(idx);
    startAuto();
    setTimeout(() => setAnimating(false), 700);
  };

  const prev = () => goTo((active - 1 + total) % total);
  const next = () => goTo((active + 1) % total);

  // position each slide: -2, -1, 0, +1, +2
  const getPos = (i) => {
    let diff = i - active;
    if (diff > total / 2)  diff -= total;
    if (diff < -total / 2) diff += total;
    return diff;
  };

const getStyle = (pos) => {
  const abs = Math.abs(pos);

  if (abs > 2) return { display: 'none' };

  const tx    = pos * 48;          // spread
  const scale = abs === 0 ? 1 : abs === 1 ? 0.80 : 0.62;
  const ry    = pos * -35;
  const zIndex = 10 - abs * 3;
  const bright = abs === 0 ? 1 : abs === 1 ? 0.60 : 0.32;
  const blur   = abs === 0 ? 0 : abs === 1 ? 2   : 5;

  return {
    transform: `translateX(${tx}%) scale(${scale}) rotateY(${ry}deg)`,
    zIndex,
    filter:    `brightness(${bright}) blur(${blur}px)`,
    pointerEvents: abs === 0 ? 'auto' : 'none',
    /* ← explicit visibility */
    opacity: 1,
    visibility: 'visible',
  };
};

  return (
    <section className="rv-section">

      {/* Header */}
      <div className="rv-header">
        <p className="rv-eyebrow">Our Signature Style</p>
        <h2 className="rv-heading">
          Every Frame, A <em className="rv-red">Masterpiece</em>
        </h2>
        <p className="rv-sub">
          Cinematic photography &amp; videography crafted for couples,
          families, and brands who demand excellence.
        </p>
      </div>

      {/* Coverflow Stage */}
      <div className="rv-stage">

        {/* Arrow left */}
        <button className="rv-arrow rv-arrow-l" onClick={prev} aria-label="Previous">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M15 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Cards */}
        <div className="rv-track">
          {slides.map((src, i) => {
            const pos = getPos(i);
            const abs = Math.abs(pos);
            return (
              <div
                key={i}
                className={`rv-card ${abs === 0 ? 'rv-card-active' : ''}`}
                style={getStyle(pos)}
                onClick={() => abs !== 0 && goTo(i)}
              >
                <img src={src} alt={`Slide ${i + 1}`} className="rv-img" />

                {/* Active card overlay */}
                {abs === 0 && (
                  <div className="rv-card-info">
                    <span className="rv-card-tag">Brand Partners Studio</span>
                    
                  </div>
                )}

                {/* Corner accents on active */}
                {abs === 0 && (
                  <>
                    <span className="rv-c rv-c-tl" />
                    <span className="rv-c rv-c-br" />
                  </>
                )}
              </div>
            );
          })}
        </div>

        {/* Arrow right */}
        <button className="rv-arrow rv-arrow-r" onClick={next} aria-label="Next">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

      </div>

      {/* Dots */}
      <div className="rv-dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`rv-dot ${i === active ? 'rv-dot-on' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to slide ${i + 1}`}
          />
        ))}
      </div>

    </section>
  );
}